import styled from '@xstyled/styled-components';

export const DropBox = styled.div`
  width: 640px;
  height: 100px;
  margin-left: -340px;
  margin-top: -14px;
`;

export const RightShape = styled.div`
  position: absolute;
  top: 2px;
  left: 2px;
  right: 2px;
  bottom: 2px;
  z-index: 2;
  background-color: white;
  padding: md;
  border-top-right-radius: xl;
  border-bottom-right-radius: xl;
  height: 100px;
  width: 320px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:after {
    content: '';
    position: absolute;
    left: -30px;
    top: 0;
    width: 0;
    height: 0;
    border-top: 50px solid;
    border-left: 30px solid transparent;
    border-top-color: white;
  }

  &:before {
    content: '';
    position: absolute;
    left: -30px;
    bottom: 0;
    width: 0;
    height: 0;
    border-bottom: 50px solid;
    border-left: 30px solid transparent;
    border-bottom-color: white;
  }
`;
